<kendo-gridlayout
  class="main-index-layout"
  [gap]="{ rows: 0 }"
  [cols]="['1fr', { width: mainContentWidth }, '1fr']"
  [rows]="[{ height: '60px' }, { height: '1fr' }]"
  [align]="{ vertical: 'top' }">
  <kendo-gridlayout-item #Topbar class="bar-background watermark" [attr.data-env]="$environmentName()" [row]="1" [col]="1" [colSpan]="3" />
  <kendo-gridlayout-item #BarContent class="bar-content-cell" [row]="1" [col]="2">
    <unity-banner-context-shared />
  </kendo-gridlayout-item>
  <kendo-gridlayout-item class="main-content-wrapper" [row]="2" [colSpan]="3">
    <kendo-gridlayout class="main-content-layout" [cols]="['1fr', { width: mainContentWidth }, '1fr']">
      <kendo-gridlayout-item #MainContent class="main-content-cell" [col]="2">
        <router-outlet />
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </kendo-gridlayout-item>
</kendo-gridlayout>
